export enum ZoomDefaultButton {
  FitToScreen,
  ZoomIn,
  ZoomOut,
  ResetZoom,
}
